<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout>
      <v-flex xs12 md6 text-xs-center v-for="i in 2" :key="'img'+i">
        <button class="hvr hvr-shrink image-button" :class="{'bot-check-vis-cen': vistos[i-1]}" @click="modal=true, text=i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 1/diapositiva-12-'+ i +'.png')" alt="">
        </button>
      </v-flex>
    </v-layout>
    <modal-app v-model="modal" width="800px" :fullscreen="false">
      <div v-if="text == 1">
        <h1 class="modal-title">LEY SARBANES – OXLEY</h1>
        <p>También conocida como Acta de Reforma de la Contabilidad Pública de Empresas y de Protección al Inversionista.</p>
        <p>Es una ley emitida en Estados Unidos como respuesta a escándalos financieros que quebraron varias empresas, afectándose la confianza inversionista.</p>
        <p>Sus principales requerimientos son:</p>
        <ul>
          <li>Implementar un sistema de control interno para el adecuado uso y compilación de información.</li>
          <li>Certificar que la información financiera no contiene datos falsos u omisiones relevantes.</li>
          <li>Que la efectividad del control interno sea verificada 90 días antes de emitir información financiera.</li>
          <li>Comunicar en la declaración de reportes financieros cualquier cambio significativo en el sistema de control interno.</li>
          <li>Todo el proceso de reservas se enmarque dentro de la matriz SOX de la Organización</li>
        </ul>
      </div>
      <div v-if="text == 2">
        <h1 class="modal-title">Código de Ética Empresarial:</h1>
        <p>La estimación, manejo y reporte de cifras de reserva y recursos, exige el más alto nivel de ética profesional en la preparación y divulgación de los resultados del proceso. Por tanto, para todo empleado de ECOPETROL S.A. ninguna circunstancia justifica el no cumplimiento del Código de Ética Empresarial.</p>
        <p>Para revisar en detalle el Código de Ética Empresarial – CEE. <a href="https://www.ecopetrol.com.co/documentos/codigo-etica-conducta-ecopetrol.pdf" target="blank">Haz clic aquí</a></p>
      </div>
    </modal-app>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 11'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      text: 1,
      vistos: [false,false],
      dialogos: [
        "Por último, en el marco regulatorio encontramos las siguientes normas a tener en cuenta. <span class='instruccion'>Haz clic en los isologos</span>" 
      ]
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos){
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/variables';
.image-button:hover img{
  box-shadow:  0 0 10px $azul;;
}
</style>
